module.exports = "/static/assets/a6d435fb872471d12813b14a2fdac81e.png";